export enum BrowseAccount {
  ADMIN = 'admin',
  ADMIN_TOKEN = 'adminToken',
  PERMISSION = 'permission',
  USER = 'USER',
}
